import { syncAccordionState } from '../modules/accordion';
import tippy from 'tippy.js';
import { initTippy } from '../modules/tippyModule';
import { lockPageScroll, unlockPageScroll } from '../modules/page-scroll-lock';

class Product {
    constructor() {
        this.init();
    }

    init() {
        this.mainArea = document.querySelector('[js-product-main-area]');
        this.bar = document.querySelector('[js-product-bar]');

        this.handleObserver();
    }

    handleObserver() {
        if (!this.bar) return;
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        this.bar.classList.add('active');
                    } else {
                        this.bar.classList.remove('active');
                    }
                });
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '100px',
            }
        );

        observer.observe(this.mainArea);
    }
}

new Product();

class ProductDownloadLoginModal {
    constructor() {
        this.modal = document.querySelector('[data-product-download-login-modal]');

        if (!this.modal) {
            return;
        }

        this.isOpen = false;
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        document.addEventListener('click', this.onDocumentClick, true);
        document.addEventListener('keydown', this.onKeyDown);
    }

    onDocumentClick(event) {
        const openTrigger = event.target.closest('[data-product-download-login]');
        const closeTrigger = event.target.closest(
            '[data-product-download-login-close], [data-product-download-login-overlay]'
        );

        if (openTrigger) {
            event.preventDefault();
            event.stopPropagation();
            this.open();
            return;
        }

        if (closeTrigger && this.modal.contains(closeTrigger)) {
            event.preventDefault();
            this.close();
        }
    }

    onKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen) {
            this.close();
        }
    }

    open() {
        this.isOpen = true;
        this.modal.setAttribute('data-open', '');
        this.modal.setAttribute('aria-hidden', 'false');
        lockPageScroll();
    }

    close() {
        if (!this.isOpen) {
            return;
        }

        this.isOpen = false;
        this.modal.removeAttribute('data-open');
        this.modal.setAttribute('aria-hidden', 'true');
        unlockPageScroll();
    }
}

new ProductDownloadLoginModal();

document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-product-recommended-more]');

    if (!trigger) {
        return;
    }

    const section = trigger.closest('[data-product-recommended-section]');

    if (!section) {
        return;
    }

    event.preventDefault();

    const extras = section.querySelectorAll(
        '[data-product-recommended-extra]'
    );
    const isExpanded = trigger.dataset.expanded === '1';
    const labelMore =
        trigger.dataset.labelMore || trigger.textContent || '';
    const labelHide = trigger.dataset.labelHide || 'Ukryj';

    extras.forEach(item => {
        item.classList.toggle('hidden', isExpanded);
    });

    trigger.dataset.expanded = isExpanded ? '0' : '1';
    trigger.textContent = isExpanded ? labelMore : labelHide;
});

jQuery(function ($) {
    const productPrice = $('[js-product-price]');
    const productBarPrice = $('[js-product-bar-price]');
    const productTitle = $('[js-product-title]');
    const defaultProductTitle =
        productTitle.attr('data-default-title') || productTitle.text() || '';
    const defaultPriceHtml =
        productPrice.attr('data-default-price') || productPrice.html();
    const productSymbol = $('[js-product-symbol]');
    const defaultSymbol = productSymbol.attr('data-default-symbol') || '';
    const symbolFormat =
        productSymbol.attr('data-symbol-format') || 'Symbol: %s';

    const formatDisplayCatalogNumber = sku => {
        const normalized = String(sku || '').trim();

        if (normalized.endsWith('-v')) {
            return normalized.slice(0, -2);
        }

        return normalized;
    };

    const formatProductSymbol = sku => {
        if (!sku) {
            return '';
        }

        return symbolFormat.replace('%s', formatDisplayCatalogNumber(sku));
    };

    const setProductSymbol = sku => {
        if (!productSymbol.length) {
            return;
        }

        const formattedSymbol = formatProductSymbol(sku);

        if (!formattedSymbol) {
            productSymbol.addClass('hidden').text('');
            return;
        }

        productSymbol.removeClass('hidden').text(formattedSymbol);
    };

    const resetProductSymbol = () => {
        setProductSymbol(defaultSymbol);
    };

    const setProductTitle = title => {
        if (!productTitle.length || !title) {
            return;
        }

        const nextTitle = String(title).trim();
        const currentTitle = productTitle.text().trim();

        if (nextTitle === currentTitle) {
            return;
        }

        productTitle.text(nextTitle);
    };

    const resetProductTitle = () => {
        setProductTitle(defaultProductTitle);
    };

    const setProductPrice = priceHtml => {
        if (typeof ajax !== 'undefined' && ajax.showProductPrices === false) {
            return;
        }

        if (!priceHtml) {
            return;
        }

        if (productPrice.length) {
            productPrice.html(priceHtml);
        }

        if (productBarPrice.length) {
            productBarPrice.html(priceHtml);
        }
    };

    const resetProductPrice = () => {
        if (productPrice.length) {
            productPrice.html(defaultPriceHtml);
        }

        if (productBarPrice.length) {
            productBarPrice.html(defaultPriceHtml);
        }
    };

    const getDefaultGalleryImages = () => {
        const wrapper = document.querySelector(
            '.woocommerce-product-gallery[data-default-gallery]'
        );

        if (!wrapper) {
            return null;
        }

        try {
            const parsed = JSON.parse(wrapper.dataset.defaultGallery || '[]');

            return Array.isArray(parsed) ? parsed : null;
        } catch (error) {
            return null;
        }
    };

    const getGalleryImagesFromVariation = variation => {
        // The custom payload is authoritative, including an intentionally empty gallery.
        if (Array.isArray(variation?.mda_gallery_images)) {
            return variation.mda_gallery_images;
        }

        if (variation?.image?.src) {
            return [
                {
                    src: variation.image.src,
                    srcset: variation.image.srcset || '',
                    thumb_src:
                        variation.image.gallery_thumbnail_src ||
                        variation.image.src,
                    alt: variation.image.alt || '',
                },
            ];
        }

        return null;
    };

    const updateVariableProductGallery = images => {
        const galleryRoot = document.querySelector(
            '.woocommerce-product-gallery .js-gallery'
        );

        if (!galleryRoot || !window.mdaUpdateProductGallery) {
            return;
        }

        window.mdaUpdateProductGallery(galleryRoot, images);
    };

    const pdpMainArea = document.querySelector('[js-product-main-area]');
    const pdpSectionsContainer = document.querySelector(
        '[data-pdp-variation-sections]'
    );
    const pdpRecommendationsContainer = document.querySelector(
        '[data-pdp-variation-recommendations]'
    );
    const pdpMadeInPolandContainer = document.querySelector(
        '[data-pdp-variation-made-in-poland]'
    );
    const pdpVariationContentDefaults = {
        sections: pdpSectionsContainer?.innerHTML || '',
        recommendations: pdpRecommendationsContainer?.innerHTML || '',
        madeInPoland: pdpMadeInPolandContainer?.innerHTML || '',
    };
    let pdpVariationContentController = null;
    let pdpVariationContentRequestId = 0;
    let pdpLastLoadedVariationId = Number(
        pdpMainArea?.dataset.pdpDefaultVariationId || 0
    );

    const setPdpVariationContainerHtml = (container, html) => {
        if (!container) {
            return;
        }

        container.innerHTML = html;
    };

    const setPdpVariationContainerLoading = (container, isLoading) => {
        if (!container) {
            return;
        }

        container.classList.toggle('is-loading', Boolean(isLoading));
        container.setAttribute(
            'aria-busy',
            isLoading ? 'true' : 'false'
        );
    };

    const syncPdpVariationAccordions = () => {
        if (!pdpSectionsContainer) {
            return;
        }

        syncAccordionState(pdpSectionsContainer);
    };

    const applyPdpVariationContent = payload => {
        if (!payload || typeof payload !== 'object') {
            return;
        }

        setPdpVariationContainerHtml(
            pdpSectionsContainer,
            String(payload.sections_html || '')
        );
        setPdpVariationContainerHtml(
            pdpRecommendationsContainer,
            String(payload.recommendations_html || '')
        );
        setPdpVariationContainerHtml(
            pdpMadeInPolandContainer,
            String(payload.made_in_poland_html || '')
        );
        syncPdpVariationAccordions();
    };

    const resetPdpVariationContent = () => {
        if (pdpVariationContentController) {
            pdpVariationContentController.abort();
            pdpVariationContentController = null;
        }

        setPdpVariationContainerLoading(pdpSectionsContainer, false);
        setPdpVariationContainerLoading(pdpRecommendationsContainer, false);
        setPdpVariationContainerLoading(pdpMadeInPolandContainer, false);
        setPdpVariationContainerHtml(
            pdpSectionsContainer,
            pdpVariationContentDefaults.sections
        );
        setPdpVariationContainerHtml(
            pdpRecommendationsContainer,
            pdpVariationContentDefaults.recommendations
        );
        setPdpVariationContainerHtml(
            pdpMadeInPolandContainer,
            pdpVariationContentDefaults.madeInPoland
        );
        pdpLastLoadedVariationId = Number(
            pdpMainArea?.dataset.pdpDefaultVariationId || 0
        );
        syncPdpVariationAccordions();
    };

    const loadPdpVariationContent = variationId => {
        if (!pdpMainArea || !pdpSectionsContainer) {
            return;
        }

        const ajaxUrl = String(pdpMainArea.dataset.pdpAjaxUrl || '').trim();
        const nonce = String(pdpMainArea.dataset.pdpNonce || '').trim();
        const productId = Number(pdpMainArea.dataset.pdpProductId || 0);
        const normalizedVariationId = Number(variationId || 0);

        if (pdpLastLoadedVariationId === normalizedVariationId) {
            return;
        }

        if (!ajaxUrl || !nonce || productId <= 0) {
            return;
        }

        if (pdpVariationContentController) {
            pdpVariationContentController.abort();
        }

        pdpVariationContentController = new AbortController();
        const requestId = ++pdpVariationContentRequestId;
        const requestBody = new URLSearchParams({
            action: 'mda_pdp_variation_content',
            nonce,
            product_id: String(productId),
            variation_id: String(normalizedVariationId),
        });

        setPdpVariationContainerLoading(pdpSectionsContainer, true);
        setPdpVariationContainerLoading(pdpRecommendationsContainer, true);
        setPdpVariationContainerLoading(pdpMadeInPolandContainer, true);

        fetch(ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: requestBody.toString(),
            signal: pdpVariationContentController.signal,
        })
            .then(response => response.json())
            .then(response => {
                if (requestId !== pdpVariationContentRequestId) {
                    return;
                }

                if (!response?.success || !response?.data) {
                    return;
                }

                applyPdpVariationContent(response.data);
                pdpLastLoadedVariationId = normalizedVariationId;
            })
            .catch(error => {
                if (error?.name === 'AbortError') {
                    return;
                }
            })
            .finally(() => {
                if (requestId !== pdpVariationContentRequestId) {
                    return;
                }

                setPdpVariationContainerLoading(pdpSectionsContainer, false);
                setPdpVariationContainerLoading(
                    pdpRecommendationsContainer,
                    false
                );
                setPdpVariationContainerLoading(
                    pdpMadeInPolandContainer,
                    false
                );
                pdpVariationContentController = null;
            });
    };

    const updateInitialVariationPrice = form => {
        if (!productPrice.length || !form.length) {
            return;
        }

        const variations = form.data('product_variations');
        if (!Array.isArray(variations) || !variations.length) {
            return;
        }

        const lockedVariationId = Number(
            form.find('input.variation_id').val() || 0
        );

        if (lockedVariationId > 0) {
            const lockedVariation = variations.find(
                variation =>
                    Number(variation?.variation_id || 0) === lockedVariationId
            );

            if (lockedVariation) {
                if (lockedVariation.price_html) {
                    setProductPrice(lockedVariation.price_html);
                }

                if (lockedVariation.sku) {
                    setProductSymbol(String(lockedVariation.sku));
                }

                return;
            }
        }

        const selectedAttributes = {};
        let hasUnselectedAttribute = false;

        form.find('select[name^="attribute_"]').each(function () {
            const select = $(this);
            const name = select.attr('name');
            const value = select.val();

            if (!name) {
                return;
            }

            selectedAttributes[name] = value;
            if (!value) {
                hasUnselectedAttribute = true;
            }
        });

        if (hasUnselectedAttribute) {
            return;
        }

        const matchedVariation = variations.find(variation => {
            if (
                !variation ||
                typeof variation !== 'object' ||
                !variation.attributes
            ) {
                return false;
            }

            return Object.entries(selectedAttributes).every(
                ([attributeName, attributeValue]) => {
                    const variationValue = variation.attributes[attributeName];

                    return (
                        variationValue === '' ||
                        variationValue === attributeValue
                    );
                }
            );
        });

        if (matchedVariation && matchedVariation.price_html) {
            setProductPrice(matchedVariation.price_html);
        }

        if (matchedVariation?.sku) {
            setProductSymbol(String(matchedVariation.sku));
        }
    };

    $(document).on(
        'found_variation',
        '.variations_form',
        function (event, variation) {
            const $form = $(this);

            if ($form.find('[js-pdp-variation-color]').length > 0) {
                const lockedVariationId = Number(
                    $form.find('input.variation_id').val() || 0
                );
                const incomingVariationId = Number(
                    variation?.variation_id || 0
                );

                if (
                    lockedVariationId > 0 &&
                    incomingVariationId > 0 &&
                    lockedVariationId !== incomingVariationId
                ) {
                    const variations = getVariationsData($form);
                    const lockedVariation = variations.find(
                        item =>
                            Number(item?.variation_id || 0) ===
                            lockedVariationId
                    );

                    if (lockedVariation) {
                        variation = lockedVariation;
                    }
                }
            }

            if (variation && variation.price_html) {
                setProductPrice(variation.price_html);
            }

            if (variation?.sku) {
                setProductSymbol(String(variation.sku));
            }

            if (variation?.mda_catalog_name) {
                setProductTitle(String(variation.mda_catalog_name));
            }

            const galleryImages = getGalleryImagesFromVariation(variation);

            if (galleryImages) {
                updateVariableProductGallery(galleryImages);
            }

            loadPdpVariationContent(variation?.variation_id || 0);
        }
    );

    $(document).on(
        'reset_data hide_variation',
        '.variations_form',
        function () {
            const $form = $(this);

            if (!$form.data('mda-variation-ready')) {
                return;
            }

            resetProductPrice();
            resetProductSymbol();
            resetProductTitle();

            const defaultGalleryImages = getDefaultGalleryImages();

            if (defaultGalleryImages) {
                updateVariableProductGallery(defaultGalleryImages);
            }

            resetPdpVariationContent();
        }
    );

    const setPdpVariationColorSelection = (container, variationId) => {
        if (!container) {
            return;
        }

        container.querySelectorAll('[js-pdp-variation-color]').forEach(button => {
            const buttonVariationId = Number(button.dataset.variationId || 0);
            button.classList.toggle('is-selected', buttonVariationId === variationId);
        });
    };

    $(document).on('click', '[js-pdp-variation-color]', function (event) {
        event.preventDefault();

        const button = event.currentTarget;
        const variationId = Number(button.dataset.variationId || 0);
        const $form = $(button).closest('.variations_form');

        if (variationId <= 0 || !$form.length) {
            return;
        }

        const variations = getVariationsData($form);
        const targetVariation = variations.find(
            variation => Number(variation?.variation_id || 0) === variationId
        );

        if (!targetVariation) {
            return;
        }

        applySingleVariationSelection($form, targetVariation, {
            lockVariationId: true,
        });
        setPdpVariationColorSelection(
            button.closest('.js-pdp-variation-colors'),
            variationId
        );
    });

    /**
     * Mirror native WooCommerce variation filtering onto styled radios.
     * WC updates the hidden <select> options; radios only reflect that state.
     */
    const syncVariationRadiosAvailability = $form => {
        if (!$form || !$form.length) {
            return;
        }

        const unavailableTooltip = String(
            $form.attr('data-unavailable-variation-tooltip') || ''
        ).trim();

        $form.find('select[name^="attribute_"]').each(function () {
            const $select = $(this);
            const name = $select.attr('name');

            if (!name) {
                return;
            }

            const availableValues = new Set();

            $select.find('option').each(function () {
                const value = $(this).val();

                // Same rules as WC: skip placeholder and disabled options.
                if (!value || $(this).prop('disabled')) {
                    return;
                }

                availableValues.add(String(value));
            });

            const selectValue = String($select.val() || '');

            $form
                .find(`.js-variation-radios input[name="${name}"]`)
                .each(function () {
                    const $input = $(this);
                    const value = String($input.attr('value') || '');
                    const isAvailable = availableValues.has(value);
                    const wrapper = $input.parent().get(0);
                    const tippyTarget = wrapper?.querySelector?.('[js-tippy]');
                    const needsUnavailableTippy =
                        !isAvailable && unavailableTooltip !== '';

                    $input.prop('disabled', !isAvailable);
                    $input.parent().toggleClass('is-unavailable', !isAvailable);
                    $input.parent().removeAttr('hidden');

                    if (needsUnavailableTippy) {
                        if (tippyTarget?._tippy) {
                            tippyTarget._tippy.destroy();
                        }

                        if (wrapper?._tippy) {
                            wrapper._tippy.setContent(unavailableTooltip);
                        } else if (wrapper) {
                            tippy(wrapper, {
                                content: unavailableTooltip,
                                allowHTML: false,
                                trigger: 'mouseenter focus',
                                touch: false,
                                hideOnClick: false,
                            });
                        }

                        $input.prop('checked', false);
                        return;
                    }

                    if (wrapper?._tippy) {
                        wrapper._tippy.destroy();
                    }

                    // Nie niszcz tippy swatcha przy syncu — klik nie powinien go zamykać.
                    if (tippyTarget && !tippyTarget._tippy) {
                        initTippy(wrapper);
                    }

                    $input.prop(
                        'checked',
                        selectValue !== '' && value === selectValue
                    );
                });
        });
    };

    // Radios drive the hidden selects — WC handles matching from there.
    $(document).on('change', '.js-variation-radios input', function () {
        const $radio = $(this);

        if ($radio.prop('disabled')) {
            return;
        }

        const $form = $radio.closest('.variations_form');
        const radioName = $radio.attr('name');
        const radioValue = $radio.attr('value');

        if (!$form.length || !radioName) {
            return;
        }

        $form
            .find(`select[name="${radioName}"]`)
            .val(radioValue)
            .trigger('change');
    });

    $(document).on(
        'woocommerce_update_variation_values',
        '.variations_form',
        function () {
            syncVariationRadiosAvailability($(this));
        }
    );

    const getVariationsData = form => {
        const variations = form.data('product_variations');

        if (Array.isArray(variations)) {
            return variations;
        }

        const rawVariations = form.attr('data-product_variations');

        if (!rawVariations) {
            return [];
        }

        try {
            const parsed = JSON.parse(rawVariations);

            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    };

    const applyVariationPresentation = ($form, targetVariation) => {
        if (targetVariation?.price_html) {
            setProductPrice(targetVariation.price_html);
        }

        if (targetVariation?.sku) {
            setProductSymbol(String(targetVariation.sku));
        }

        if (targetVariation?.mda_catalog_name) {
            setProductTitle(String(targetVariation.mda_catalog_name));
        }

        const galleryImages = getGalleryImagesFromVariation(targetVariation);

        if (galleryImages) {
            updateVariableProductGallery(galleryImages);
        }

        $form
            .find('.woocommerce-variation-add-to-cart')
            .removeClass('woocommerce-variation-add-to-cart-disabled');
        $form
            .find('.single_add_to_cart_button')
            .removeClass('disabled wc-variation-selection-needed');

        syncProductBarVariationForm($form);
    };

    const applySingleVariationSelection = ($form, targetVariation, options = {}) => {
        if (!targetVariation?.attributes) {
            return false;
        }

        const lockVariationId = Boolean(options.lockVariationId);

        Object.entries(targetVariation.attributes).forEach(([name, value]) => {
            if (!value) {
                return;
            }

            const select = $form.find(`select[name="${name}"]`);

            if (select.length) {
                select.val(value);
            }

            $form
                .find(
                    `.js-variation-radios input[name="${name}"][value="${value}"]`
                )
                .prop('checked', true);
        });

        if (targetVariation.variation_id) {
            $form
                .find('input.variation_id')
                .val(String(targetVariation.variation_id));
        }

        if (lockVariationId) {
            $form.trigger('found_variation', [targetVariation]);
            applyVariationPresentation($form, targetVariation);

            return true;
        }

        $form.find('select[name^="attribute_"]').trigger('change');
        $form.trigger('check_variations');
        $form.trigger('found_variation', [targetVariation]);
        applyVariationPresentation($form, targetVariation);
        updateInitialVariationPrice($form);

        return true;
    };

    const getVariationAttributesFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        const attributes = {};

        params.forEach((value, key) => {
            if (key.startsWith('attribute_') && value) {
                attributes[key] = value;
            }
        });

        return attributes;
    };

    const applyVariationAttributesToForm = ($form, attributes) => {
        if (!attributes || typeof attributes !== 'object') {
            return false;
        }

        let hasAttributes = false;

        Object.entries(attributes).forEach(([name, value]) => {
            if (!value) {
                return;
            }

            hasAttributes = true;

            const select = $form.find(`select[name="${name}"]`);

            if (select.length) {
                select.val(value);
            }

            $form
                .find(
                    `.js-variation-radios input[name="${name}"][value="${value}"]`
                )
                .prop('checked', true);
        });

        if (!hasAttributes) {
            return false;
        }

        $form.find('select[name^="attribute_"]').trigger('change');
        $form.trigger('check_variations');

        return true;
    };

    const applyVariationSelectionFromUrl = form => {
        const $form = form instanceof jQuery ? form : jQuery(form);

        if (!$form.length) {
            return false;
        }

        const variationIdFromUrl = Number(
            new URLSearchParams(window.location.search).get('variation_id') || 0
        );

        if (variationIdFromUrl > 0) {
            const variations = getVariationsData($form);
            const targetVariation = variations.find(
                variation =>
                    Number(variation?.variation_id || 0) === variationIdFromUrl
            );

            if (targetVariation) {
                const hasPerVariationColorSwatches =
                    $form.find('[js-pdp-variation-color]').length > 0;
                const applied = applySingleVariationSelection($form, targetVariation, {
                    lockVariationId: hasPerVariationColorSwatches,
                });

                if (applied && hasPerVariationColorSwatches) {
                    setPdpVariationColorSelection(
                        $form.find('.js-pdp-variation-colors').get(0),
                        variationIdFromUrl
                    );
                }

                return applied;
            }
        }

        const urlAttributes = getVariationAttributesFromUrl();
        const attributeNames = Object.keys(urlAttributes);

        if (!attributeNames.length) {
            return false;
        }

        const variations = getVariationsData($form);
        const targetVariation = variations.find(variation => {
            if (!variation?.attributes) {
                return false;
            }

            return attributeNames.every(attributeName => {
                const variationValue = variation.attributes[attributeName];
                const urlValue = urlAttributes[attributeName];

                return variationValue === '' || variationValue === urlValue;
            });
        });

        if (targetVariation) {
            return applySingleVariationSelection($form, targetVariation);
        }

        return applyVariationAttributesToForm($form, urlAttributes);
    };

    const autoSelectSingleVariation = form => {
        const $form = form instanceof jQuery ? form : jQuery(form);

        if (!$form.length) {
            return false;
        }

        const variations = getVariationsData($form);

        if (!variations.length) {
            return false;
        }

        let targetVariation = null;

        if (variations.length === 1) {
            targetVariation = variations[0];
        } else {
            const selects = $form.find('select[name^="attribute_"]');
            let hasOnlySingleOptions = selects.length > 0;

            selects.each(function () {
                const options = $(this)
                    .find('option')
                    .filter(function () {
                        return $(this).val() !== '';
                    });

                if (options.length !== 1) {
                    hasOnlySingleOptions = false;
                }
            });

            if (hasOnlySingleOptions) {
                targetVariation =
                    variations.find(
                        variation =>
                            variation.is_in_stock && variation.is_purchasable
                    ) || variations[0];
            }
        }

        return applySingleVariationSelection($form, targetVariation);
    };

    window.mdaAutoSelectSingleVariation = autoSelectSingleVariation;

    const syncProductBarVariationForm = sourceForm => {
        const $sourceForm =
            sourceForm instanceof jQuery ? sourceForm : jQuery(sourceForm);
        const $barForm = $('[js-product-bar-variation-form]');

        if (!$sourceForm.length || !$barForm.length) {
            return;
        }

        $sourceForm.find('[name^="attribute_"]').each(function () {
            const input = $(this);
            const name = input.attr('name');

            if (!name) {
                return;
            }

            $barForm.find(`[name="${name}"]`).val(input.val() || '');
        });

        const variationId = String(
            $sourceForm.find('[name="variation_id"]').val() || ''
        );
        const hasVariationId = variationId !== '' && variationId !== '0';
        const $addToCartButton = $barForm.find('.single_add_to_cart_button');

        $barForm.find('[name="variation_id"]').val(variationId);
        $addToCartButton.toggleClass(
            'disabled wc-variation-selection-needed',
            !hasVariationId
        );
        $addToCartButton.prop('disabled', !hasVariationId);
    };

    const initVariationForm = form => {
        const $form = form instanceof jQuery ? form : jQuery(form);

        if (!$form.length) {
            return;
        }

        const isProductBarForm = $form.is('[js-product-bar-variation-form]');
        const hasPerVariationColorSwatches =
            $form.find('[js-pdp-variation-color]').length > 0;

        if (!isProductBarForm) {
            const appliedFromUrl = applyVariationSelectionFromUrl($form);

            if (!appliedFromUrl) {
                const presetVariationId = Number(
                    $form.find('input.variation_id').val() || 0
                );

                if (presetVariationId > 0) {
                    const variations = getVariationsData($form);
                    const presetVariation = variations.find(
                        variation =>
                            Number(variation?.variation_id || 0) ===
                            presetVariationId
                    );

                    if (presetVariation) {
                        applySingleVariationSelection($form, presetVariation, {
                            lockVariationId: hasPerVariationColorSwatches,
                        });

                        if (hasPerVariationColorSwatches) {
                            setPdpVariationColorSelection(
                                $form.find('.js-pdp-variation-colors').get(0),
                                presetVariationId
                            );
                        }
                    } else {
                        autoSelectSingleVariation($form);
                    }
                } else {
                    autoSelectSingleVariation($form);
                }
            }

            updateInitialVariationPrice($form);
            syncProductBarVariationForm($form);
            syncVariationRadiosAvailability($form);
            return;
        }

        syncProductBarVariationForm(
            $('.variations_form').not('[js-product-bar-variation-form]').first()
        );
    };

    const bootVariationForm = $form => {
        initVariationForm($form);
        $form.data('mda-variation-ready', true);
    };

    $('.variations_form').each(function () {
        const $form = $(this);

        if ($form.hasClass('wc-variation-form')) {
            bootVariationForm($form);
        }
    });

    $(document.body).on('wc_variation_form', '.variations_form', function () {
        bootVariationForm($(this));
    });

    $(document).on(
        'change',
        '.variations_form select[name^="attribute_"], .variations_form input[name^="attribute_"]',
        function () {
            syncProductBarVariationForm($(this).closest('.variations_form'));
        }
    );

    $(document).on('found_variation', '.variations_form', function () {
        syncProductBarVariationForm($(this));
    });

    $(document).on(
        'reset_data hide_variation',
        '.variations_form',
        function () {
            syncProductBarVariationForm($(this));
        }
    );

    $(document).on('submit', 'form.cart', function (event) {
        if (!document.body.classList.contains('single-product')) {
            return;
        }

        if (!window.mdaMinicart) {
            return;
        }

        event.preventDefault();
        window.mdaMinicart.addFromProductForm(this);
    });
});
